import { FC } from 'react'

import {
	Alert,
	Container,
	Header,
	SpaceBetween
} from '@cloudscape-design/components'

import AccountNetworkDetailsEditor from './AccountNetworkDetailsEditor'

export type PlatformSubgroupValidation = {
	error?: string
	info?: string
}

type AccountNetworkApprovalPanelProps = {
	formValues: Record<string, unknown>
	setFormValues: (fieldName: string, value: unknown) => void
	isProduction: boolean
	accountType?: string
	onValidityChange?: (isValid: boolean) => void
	platformSubgroupValidation?: PlatformSubgroupValidation
	networkHeaderVariant?: 'h2' | 'h3'
	networkPrefillGeneration?: number
	allowThirdAzToggle?: boolean
}

const AccountNetworkApprovalPanel: FC<AccountNetworkApprovalPanelProps> = ({
	formValues,
	setFormValues,
	isProduction,
	accountType,
	onValidityChange,
	platformSubgroupValidation,
	networkHeaderVariant = 'h3',
	networkPrefillGeneration,
	allowThirdAzToggle
}) => (
	<SpaceBetween direction="vertical" size="l">
		{platformSubgroupValidation?.error && (
			<Alert type="error" statusIconAriaLabel="Error">
				{platformSubgroupValidation.error}
			</Alert>
		)}
		{platformSubgroupValidation?.info && (
			<Alert type="info" statusIconAriaLabel="Info">
				{platformSubgroupValidation.info}
			</Alert>
		)}

		<Container header={<Header variant={networkHeaderVariant}>Network Details</Header>}>
			<AccountNetworkDetailsEditor
				formValues={formValues}
				setFormValues={setFormValues}
				isProduction={isProduction}
				accountType={accountType}
				onValidityChange={onValidityChange}
				networkPrefillGeneration={networkPrefillGeneration}
				allowThirdAzToggle={allowThirdAzToggle}
			/>
		</Container>
	</SpaceBetween>
)

export default AccountNetworkApprovalPanel
